import PageTitles from '../../globals/page_titles'
import env from '@polleverywhere/core/lib/env'
import Survey from '@polleverywhere/core/lib/models/survey'
import saveFeature from '../../util/save_feature'
import URI from 'urijs'

export default async function optOutFeedback (state, appOptions, lastPage) {
  const OptOutFeedback = (await import(/* webpackChunkName: 'component-feedback' */ '../../components/feedback')).default

  // Short circuit if the page has changed during async loading
  if (state.get('page') !== 'opt-out') { return }

  const view = new OptOutFeedback({
    user: state.get('user'),
    model: new Survey({ participant_key: env.get('opt_out_feedback_participant_key') }),
    title: PageTitles.optOutFeedback,
    submitControl: 'opt-out-send',

    // allow empty forms to be submitted
    allowEmpty: true
  })

  view.on('complete', () => {
    saveFeature(state.get('user'), 'enable_singularity_web', false)
      .then(() => {
        window.location.href = new URI(appOptions.mode === 'integration' ? env.get('web_presenter_url') : env.get('api_url') + 'my/polls/')
      })
  })

  view.on('done', () => state.changePage(lastPage))
  return view
}
